import { render, staticRenderFns } from "./CardMethod.vue?vue&type=template&id=e38b35da&scoped=true"
import script from "./CardMethod.vue?vue&type=script&lang=js"
export * from "./CardMethod.vue?vue&type=script&lang=js"
import style0 from "./CardMethod.vue?vue&type=style&index=0&id=e38b35da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38b35da",
  null
  
)

export default component.exports